import { useMemo } from 'react';
import { getConfig } from './utils';
import type { ConversationAssistantConfig } from '@atlassian/conversation-assistant-widget/types';

const CONFIG = getConfig();

export const useAssistantConfig = (
	credentials: RequestCredentials | undefined,
	conversationContext?: Record<string, unknown>,
): ConversationAssistantConfig => {
	return useMemo(() => {
		return {
			...CONFIG,
			assistanceServiceConfig: {
				...CONFIG.assistanceServiceConfig,
				credentials: credentials ?? CONFIG.assistanceServiceConfig?.credentials,
			},
			conversationContext,
		};
	}, [credentials, conversationContext]);
};
